import React from "react";
import { AuditLogDetailData } from "../../types/AuditLog";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export interface ComponentProps {
  details: AuditLogDetailData[];
}
const headCellStyle = {
  backgroundColor: "#000080",
  color: "white",
  fontWeight: "bold",
};
const AuditDetail: React.FC<ComponentProps> = ({ details }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ maxHeight: 450, backgroundColor: "#d7e1f2ff" }}
    >
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: "#000080", color: "#ffffff" }}>
            <TableCell sx={headCellStyle}>FIELD NAME</TableCell>
            <TableCell sx={headCellStyle}>OLD VALUE</TableCell>
            <TableCell sx={headCellStyle}>NEW VALUE</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {details.map((item) => (
            <TableRow>
              <TableCell>{item.fieldName}</TableCell>
              <TableCell>{item.oldValue}</TableCell>
              <TableCell>{item.newValue}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AuditDetail;
